import { grey } from '@mui/material/colors';
import type { ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

export default function SelectPlaceholder({ children }: Props) {
  return <span style={{ color: grey[500] }}>{children}</span>;
}
